import { ALL_ICONS } from "../../../assets/icons/AllIcons";
import { iife } from "../../../helper/helper_two";
import PerpageComp from "../perpage/PerpageComp";
import "./PaginationFragment.css";

interface myComponentProps {
  hidePagination?: boolean;
  onPageChange?: (param?: any) => void;
  currentPage?: string | number;
  totalPage?: string | number;
  perPage?: string | number;
  showPerPage?: boolean;
}

const PaginationFragment = ({
  currentPage,
  hidePagination,
  onPageChange,
  perPage,
  totalPage,
  showPerPage,
}: myComponentProps) => {
  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= Number(totalPage)) {
      onPageChange && onPageChange(page);
    }
  };

  const CurrentPage = iife(() => {
    if (Number(currentPage) > Number(totalPage)) return "";

    return (Number(currentPage) - 1) * Number(perPage) + 1;
  });

  const TotalPage =
    String(
      Math.min(
        Number(currentPage || 1) * Number(perPage || 1),
        Number(totalPage || 1)
      )
    ) || "1";

  if (hidePagination) {
    return <></>;
  }

  return (
    <div className="smart-snd-pagination-general-wrap-index">
      {/* perpage start */}
      {showPerPage && <PerpageComp />}
      {/* perpage end */}
      <div className="inner-content-wrap">
        <p className="text">{`${CurrentPage || "1"} - ${TotalPage || "1"} of ${
          totalPage || "1"
        }`}</p>
        {/* button start */}
        <div
          onClick={() => {
            if (Number(currentPage) !== 1) {
              handlePageChange(Number(currentPage) - 1);
            }
          }}
          className={`btn btn-left ${
            Number(currentPage) === 1 ? "btn-disabled" : ""
          }`}
        >
          <figure className="img-box">{ALL_ICONS?.chevron_left}</figure>
        </div>
        {/* button end */}
        {/* button start */}
        <div
          className={`btn btn-right ${
            Number(TotalPage) >= Number(totalPage) ? `btn-disabled` : ``
          }`}
          onClick={() => {
            if (Number(TotalPage) < Number(totalPage)) {
              handlePageChange(Number(currentPage) + 1);
            }
          }}
        >
          <figure className="img-box">{ALL_ICONS?.chevron_left}</figure>
        </div>
        {/* button end */}
      </div>
    </div>
  );
};

export default PaginationFragment;
